export default class ClientsImpactCalculatorsEdit {

  constructor() {}

  render() {

    // Enable section on select
    $('.enabled-section-input').change(function() {
    	let hiddenInput = $(this).closest('.custom-control').find('.hidden-destroy');
      if ($(this).is(':checked')) {
        hiddenInput.val('false');
      } else {
        hiddenInput.val('true');
      }
    })

  }

}